export const ohMySimsModsTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('Exception') !== -1 && desyncdata.indexOf('ohmysims:') !== -1) {
			return {
				type: 'ohMySimsModsTest',
				color: 'IndianRed',
				title: 'Outdated mods by ohmysims',
				text: 'You\'re potentially using an outdated version of mod by ohmysims.',
				description: 'Remove all files related to mods made by ohmysims and check if there is a recent update available.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>321b5eab31e7a5ba5bad40bf</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-09-27 15:43:33</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>tunable.py:1595</categoryid>
        <desyncid>321b5eab31e7a5ba5bad40bf</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[manus] Exception while finalizing tuning for &lt;class 'sims4.tuning.instances.ohmysims:iceCream_PurchasePicker'&gt;. (TunableMinimumLengthError)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 150, in c_api_server_init_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\core_services.py&quot;, line 164, in start_service_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 335, in start_single_service
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 104, in update_incremental_start
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 144, in _execute_gen
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 450, in load_data_into_class_instances
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 433, in load_data_into_class_instances
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 658, in load_from_xml
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 703, in feed
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 747, in _load_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 796, in _load_tunable
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1188, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 820, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 371, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1595, in load_etree_node
sims4.tuning.tunable_errors.TunableMinimumLengthError
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/authors/ohMySimsModsTest.js